<template>
  <div>
    <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
      <CRow class="flex-flow-column">
        <CCol>
          <span>{{ $t("hotelUser.title") }}</span>
        </CCol>

        <p class="desc">{{ $t("hotelUser.desc") }}</p>
      </CRow>
      <CButton
        @click="navToNew(null)"
        size="sm"
        color="success"
        class="ml-auto btn-lit-blue mob-w100"
      >{{ $t("hotelUser.addUser") }}</CButton>
    </CCardHeader>
    <CAlert v-if="alertValue" show color="danger">
      <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
        <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
      </div>
      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
        <span>{{$t("cAlert.errorCode")+' : '}}</span>
        <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
      </div>
      <div v-if="alertValue&&alertValue.constructor==String">
        <p>{{alertValue}}</p>
      </div>
    </CAlert>
    <div class="row">
     
      <div class="col">
         <div class="col">
              <label>{{  $t("hotelUser.userName") }}</label>
      </div>
        <ValidationProvider :rules="'required'" v-slot="{ errors }">
          <multiselect
            v-model="filter.selUser"
          
            :allow-empty="false"
            :options="filter.lsUserName"
            :showLabels="false"
            :placeholder="$t('hotelUser.usersPl')"
           
          >
            <template #noResult>
              <strong>{{$t('hotelUser.listEmpty')}}</strong>
            </template>
          </multiselect>
          <div v-if="errors && errors[0]" class="invalid-feedback icon">
            <span>{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
      <div class="col">
        <div class="col">
              <label>{{  $t("hotelUser.role") }}</label>
      </div>
        <ValidationProvider :rules="'required'" v-slot="{ errors }">
          <multiselect
            v-model="filter.selRole"
            :allow-empty="false"
            :options="filter.lsRole"
            :showLabels="false"
            :placeholder="$t('hotelUser.role')"
           
          >
            <template #noResult>
              <strong>{{$t('hotelUser.listEmpty')}}</strong>
            </template>
          </multiselect>
          <div v-if="errors && errors[0]" class="invalid-feedback icon">
            <span>{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
      <div class="col">
        <div class="col">
              <label>{{  $t("hotelUser.emailId") }}</label>
      </div>
        <ValidationProvider :rules="'required'" v-slot="{ errors }">
          <multiselect
            v-model="filter.selEmailId"
            :allow-empty="false"
            :options="filter.lsEmail"
            :showLabels="false"
            :placeholder="$t('hotelUser.emailId')"
           
          >
            <template #noResult>
              <strong>{{$t('hotelUser.listEmpty')}}</strong>
            </template>
          </multiselect>
          <div v-if="errors && errors[0]" class="invalid-feedback icon">
            <span>{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
      <div class="col">
        <div class="col">
              <label>  {{$t("hotelUser.status")}}</label>
      </div>
        <ValidationProvider :rules="'required'" v-slot="{ errors }">
          <multiselect
            v-model="filter.selStatus"
            :allow-empty="false"
            :options="filter.lsStatus"
            :showLabels="false"
            :placeholder="$t('hotelUser.status')"
           
          >
            <template #noResult>
              <strong>{{$t('hotelUser.listEmpty')}}</strong>
            </template>
          </multiselect>
          <div v-if="errors && errors[0]" class="invalid-feedback icon">
            <span>{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>

     

      <div class="d-flex justify-content-end">

         <div md="3" sm="6" xs="12" class="col align-center text-left mt-auto">
           
              <div>
                <CButton
                  @click.stop="onFilterUsers()"
                  class="btn-outline-success ml-0px"
                > {{$t('hotelUser.apply')}}</CButton>
              </div>
           
          </div>
        


        <span @click="clearFilters" class="clear_statement mb-10px">{{$t('agentDeposit.clear')}}</span>
      </div>
    </div>
    <div >
      <div v-if="listHotelUsers&&listHotelUsers.length>0">
        <CCardBody
          class="card assign pricing-card"
          v-for="(user,index) in listHotelUsers"
          :key="index"
        >
          <table  @click.stop="navToNew(user)">
            <thead>
              <tr>
                <th>
                  <span>{{$t("hotelUser.userName")}}</span>
                </th>
                <th>
                  <span>{{$t("hotelUser.role")}}</span>
                </th>
                <th>
                  <span>{{$t("hotelUser.emailId")}}</span>
                </th>
                <th>
                  <span>{{$t("hotelUser.status")}}</span>
                </th>

                <th>
                  <span></span>
                </th>
                <th>
                  <span></span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="max-w-65px">
                  <div v-if="user.firstname">
                    <div>{{user.firstname+user.lastname}}</div>
                  </div>
                  <div v-else>{{'-'}}</div>
                </td>
                <td class="max-w-65px">
                  <div v-if="user.roles">
                    <div>
                      <span v-for="(role,index) in user.roles" :key="index">{{role}}</span>
                    </div>
                  </div>
                  <div v-else>{{'-'}}</div>
                </td>
                <td class="max-w-65px">
                  <div v-if="user.emailid">
                    <div>{{user.emailid}}</div>
                  </div>
                  <div v-else>{{'-'}}</div>
                </td>
                <td class="max-w-65px">
                  <div>
                    <div>{{user.isactive?$t("hotelUser.active"):$t("hotelUser.inactive")}}</div>
                  </div>
                </td>

                <td class="max-w-65px">
                  <CRow>
                    <CCol>
                      <!-- v-if="permission.canEdit"
                      @click.stop="navToNew(user)"-->
                      <div    @click.stop="navToNew(user)"
                        col="2.5"
                        class="edit-icon icon-25px c-pointer"
                        color="info removewrap"
                        v-c-tooltip.hover="{ content: $t('hotelUser.edit') , active:false }"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="512pt"
                          viewBox="0 0 512 512"
                          width="512pt"
                          style="fill:#3c4b64;"
                        >
                          <path
                            d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"
                          />
                          <path
                            d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"
                          />
                          <path
                            d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"
                          />
                        </svg>
                      </div>
                    </CCol>

                    <!-- <CCol>
                     v-if="permission.canDelete"
                      @click="onConfirmDeleteUser(user)
                      <div @click="onConfirmDeleteUser(user)"
                        col="2.5"
                        size="sm"
                        color="danger"
                        v-c-tooltip.hover="{ content: $t('hotelUser.delete') , active:false }"
                        class="icon-25px c-pointer"
                      >
                        <CIcon style="color: #cd0606;font-size:22px;" name="cil-trash" size="lg"></CIcon>
                      </div>
                    </CCol> -->
                  </CRow>
                </td>
              </tr>
            </tbody>
          </table>
        </CCardBody>
      </div>

      <div v-else class="text-center my-5">
                <div v-if="isLoading" data-v-211fa86d="" role="status" aria-hidden="false" class="spinner-grow spinner-grow-lg text-primary" aria-label="Loading"></div>

        <span v-else>{{listOrgHotelUsers&&listOrgHotelUsers.length>0?$t('hotelUser.listEmptyByFilter'):$t('hotelUser.listEmpty')}}</span>
      </div>
    </div>
    <cAlertModal
      v-if="isShowAlertModal"
      :key="'users'+alertCount"
      :buttonList="modalButton"
      :status="modalStatus"
      :isShowIcon="true"
      :show="isShowAlertModal"
      :desc="confirmTxt"
    ></cAlertModal>
  </div>
</template>
<script>
import cReviewHotel from "../../../components/hms/cReviewHotel";
import router, { navigate } from "../../../router/index";
import {
  COMPONENT_NAME,
  PATHNAME,
  ALERT_MODAL_STATUS,
  DEFAULT_DROPDOWN_STATUS, ORDER
} from "../../../util/constants";
import BaseConfiguration from "../../../config/base.js";
import Logger from "../../../services/logger";
import SERVICE_URL, { LOG_TYPE, HTTP_CODES } from "../../../config/API_DATA";
import { mapGetters, mapActions } from "vuex";
import cRoomInfoBox from "../../../components/hms/manage/hotelInfo/cRoomInfoBox";
import apiGetAllHmsUsers from "../../../services/apiGetAllHmsUsers";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../../util/apiValidate";
import { getErrorAlertValue, handleJWT, cloneData, OrderByList } from "../../../util/util";
import cAlertModal from "../../../components/form/cAlertModal";
import Vue from "vue";
import apiDeleteHotelTariff from "../../../services/apiDeleteHotelTariff";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";

export default {
  name: COMPONENT_NAME.HOTEL_USERS_ALL,

  components: {
    cReviewHotel,
    cRoomInfoBox,
    cAlertModal,
    ValidationProvider,
    Multiselect
  },
  data: () => {
    return {
      listOrgHotelUsers: [],
      listHotelUsers: [],
      alertValue: null,
      alertCount: 0,
      modalStatus: ALERT_MODAL_STATUS.INFO,
      modalButton: null,
      isShowAlertModal: false,
      confirmTxt: null,
      alertCount: 0,
      selUserObj: null,
      filter: {
        lsUserName: [],
        lsRole: [],
        lsEmail: [],
        lsStatus: [],
        selRole: DEFAULT_DROPDOWN_STATUS.ALL,
        selUser: DEFAULT_DROPDOWN_STATUS.ALL,
        selEmailId: DEFAULT_DROPDOWN_STATUS.ALL,
        selStatus: DEFAULT_DROPDOWN_STATUS.ALL
      },
      isLoading:true,
    };
  },
  computed: {
    ...mapGetters("shmsManage", {
      sHotelObj: "GET_SEL_HOTEL"
    }),
    ...mapGetters("sHotelInfo", {
      sRoomObj: "GET_HOTEL_ROOM_OBJ"
    }),
  
  },
  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      let listHotelUsers = await this.getHmsUsers();
      if (listHotelUsers) {
        listHotelUsers = OrderByList(listHotelUsers,this.getPropToSort,ORDER.ASC)
        this.listHotelUsers = listHotelUsers;
        this.listOrgHotelUsers = cloneData(listHotelUsers);
        this.getDpValuesToFilter(listHotelUsers);
      }
      this.isLoading=false;
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.TARIFF_ALL,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  computed: {
    ...mapGetters("shmsManage", {
      GET_HOTEL_LS: "GET_HOTEL_LS"
    })
  },
  methods: {
    ...mapActions("sHmsUser", {
      SET_SEL_USER: "SET_SEL_USER",
     
    }),

    getPropToSort(pUsers) {
        let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getPropToSort");
         if(pUsers)
         {
           retValue =pUsers.firstname.toString().toLowerCase()
         }
         else
         throw 'invalid user obj'
    
        } catch (err) {
                let body = Logger.buildRequest(
                   COMPONENT_NAME.HOTEL_USERS_ALL,
                  "error in getPropToSort",
                  err.toString(),
                  "getPropToSort",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 
    clearFilters() {
      try {
        if (BaseConfiguration.isDebug) console.log("clearFilters");
        this.filter.selRole = DEFAULT_DROPDOWN_STATUS.ALL;
        this.filter.selUser = DEFAULT_DROPDOWN_STATUS.ALL;
        this.filter.selEmailId = DEFAULT_DROPDOWN_STATUS.ALL;
        this.filter.selStatus = DEFAULT_DROPDOWN_STATUS.ALL;
        this.listHotelUsers = cloneData(this.listOrgHotelUsers);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.HOTEL_USERS_ALL,
          "error in clearFilters",
          err.toString(),
          "clearFilters",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onFilterUsers(pValue) {
      try {
        if (BaseConfiguration.isDebug) console.log("onFilterUsers");
        let lsUsers = cloneData(this.listOrgHotelUsers);


  
        if (this.filter.selUser != DEFAULT_DROPDOWN_STATUS.ALL) {
          lsUsers = lsUsers.filter((item, index) => {
            return item.firstname + " " + item.lastname == this.filter.selUser;
          });
        }
        if (this.filter.selRole != DEFAULT_DROPDOWN_STATUS.ALL) {
          lsUsers = lsUsers.filter((item, index) => {
            return item.roles[0] == this.filter.selRole;
          });
        }
        if (this.filter.selEmailId != DEFAULT_DROPDOWN_STATUS.ALL) {
          lsUsers = lsUsers.filter((item, index) => {
            return item.emailid == this.filter.selEmailId;
          });
        }
        if (this.filter.selStatus != DEFAULT_DROPDOWN_STATUS.ALL) {
          lsUsers = lsUsers.filter((item, index) => {
            if (this.filter.selStatus == DEFAULT_DROPDOWN_STATUS.ALL) {
              return true;
            } else if (
              item.isactive == true &&
              this.filter.selStatus == DEFAULT_DROPDOWN_STATUS.ACTIVE
            ) {
              return true;
            } else if (
              item.isactive == false &&
              this.filter.selStatus == DEFAULT_DROPDOWN_STATUS.INACTIVE
            ) {
              return true;
            }
          });
        }

        this.listHotelUsers = lsUsers;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.HOTEL_USERS_ALL,
          "error in onFilterUsers",
          err.toString(),
          "onFilterUsers",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getDpValuesToFilter(pUsers) {
      try {
        if (BaseConfiguration.isDebug) console.log("getDpValuesToFilter");
        let filter = {
          lsUserName: [],
          lsRole: [],
          lsEmail: [],
          lsStatus: []
        };
        filter.lsUserName.push(DEFAULT_DROPDOWN_STATUS.ALL);
        filter.lsRole.push(DEFAULT_DROPDOWN_STATUS.ALL);
        filter.lsEmail.push(DEFAULT_DROPDOWN_STATUS.ALL);

        pUsers.forEach(function(item, index) {
          if (
            !filter.lsUserName.includes(item.firstname + " " + item.lastname)
          ) {
            filter.lsUserName.push(item.firstname + " " + item.lastname);
          }
          if (!filter.lsRole.includes(item.roles[0])) {
            filter.lsRole.push(item.roles[0]);
          }
          if (!filter.lsEmail.includes(item.emailid)) {
            filter.lsEmail.push(item.emailid);
          }
        });
        Object.keys(DEFAULT_DROPDOWN_STATUS).forEach(key => {
          filter.lsStatus.push(DEFAULT_DROPDOWN_STATUS[key]);
        });
        this.filter.lsUserName = filter.lsUserName;
        this.filter.lsRole = filter.lsRole;
        this.filter.lsEmail = filter.lsEmail;
        this.filter.lsStatus = filter.lsStatus;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.HOTEL_USERS_ALL,
          "error in getDpValuesToFilter",
          err.toString(),
          "getDpValuesToFilter",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    showAlertModal(status, val) {
      this.isShowAlertModal = true;
      this.alertCount += 1;
      this.modalStatus = status;
      this.confirmTxt = val;

      if (status == ALERT_MODAL_STATUS.INFO) {
        this.modalButton = [
          {
            name: this.$t("hotelUser.noBtn"),
            func: this.toggleShowAlertModal
          },
          {
            name: this.$t("hotelUser.yesBtn"),
            func: this.onDeleteUser
          }
        ];
      } else if (status == ALERT_MODAL_STATUS.SUCCESS) {
        this.modalButton = [
          {
            name: this.$t("hotelUser.okBtn"),
            func: this.onSuccessDelete
          }
        ];
      } else if (status == ALERT_MODAL_STATUS.FAIL) {
        this.modalButton = [
          {
            name: this.$t("hotelUser.okBtn"),
            func: this.toggleShowAlertModal
          }
        ];
      }
    },
    toggleShowAlertModal() {
      this.isShowAlertModal = !this.isShowAlertModal;
    },
    onSuccessDelete() {
      try {
        if (BaseConfiguration.isDebug) console.log("onSuccessDelete");
        this.isShowAlertModal = false;
       
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.HOTEL_USERS_ALL,
          "error in onSuccessDelete",
          err.toString(),
          "onSuccessDelete",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async onDeleteUser() {
      try {
        if (BaseConfiguration.isDebug) console.log("onDeleteUser");
        if (this.selTariffObj && this.selTariffObj.tariffid) {
          let hotelDeleteRes = await this.deleteUser(
            this.sHotelObj.hotelid,
            this.selTariffObj.tariffid
          );
          if (hotelDeleteRes) {
            this.showAlertModal(
              ALERT_MODAL_STATUS.SUCCESS,
              this.$t("hotelUser.deleteUserSuccDesc")
            );
          } else {
            this.showAlertModal(ALERT_MODAL_STATUS.FAIL, this.alertValue);
          }
        } else {
          throw "invalid hotelid";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.HOTEL_USERS_ALL,
          "error in onDeleteUser",
          err.toString(),
          "onDeleteUser",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async deleteUser(pHotelId, pTariffId) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("deleteUser");
        let tariffReq = apiDeleteHotelTariff.buildRequest(pHotelId, pTariffId);

        if (tariffReq) {
          let hotelRes = await apiDeleteHotelTariff.getResponse(tariffReq);

          if (VALIDATE_SUCCESS_RES(hotelRes)) {
            this.alertValue = null;
            retValue = hotelRes.data.data;
          } else {
            let error = getErrorMessage(hotelRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error, true, true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.HOTEL_USERS_ALL,
          "error in deleteUser",
          err.toString(),
          "deleteUser",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    onConfirmDeleteUser(pSelUserObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("onConfirmDeleteUser");
        this.selUserObj = pSelUserObj;
        this.showAlertModal(
          ALERT_MODAL_STATUS.INFO,
          this.$t("hotelUser.deleteUserConfirmation")
        );
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.HOTEL_USERS_ALL,
          "error in onConfirmDeleteUser",
          err.toString(),
          "onConfirmDeleteUser",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getHmsUsers() {
      let returnValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getHmsUsers");

        let fareRuleReq = apiGetAllHmsUsers.buildRequest();

        if (fareRuleReq) {
          let fareRuleRes = await apiGetAllHmsUsers.getResponse(fareRuleReq);
          if (VALIDATE_SUCCESS_RES(fareRuleRes)) {
            this.alertValue = null;
            returnValue = fareRuleRes.data.data.users;
          } else {
            let error = getErrorMessage(fareRuleRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.HOTEL_USERS_ALL,
          "error in  getHmsUsers",
          err.toString(),
          "getHmsUsers",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },
    navToNew(pUser) {
      try {
        if (BaseConfiguration.isDebug) console.log("navToNew");
        if (pUser) {
          this.SET_SEL_USER(pUser);
        } else {
          this.SET_SEL_USER(null);
        }
        navigate(PATHNAME.HOTEL_USERS_NEW);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_ALL,
          "error in navToNew",
          err.toString(),
          "navToNew",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  }
};
</script>